import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PageModal from "UIPalette/PageModal/PageModal";
import FadeTransition from "UIPalette/FadeTransition/FadeTransition";
import WaveBackground from "UIPalette/WaveBackground/WaveBackground";
import { SupportOption } from "../../enums/supportMoments/supportMoments";

type ReassuranceScreenProps = {
  option: SupportOption;
  onBeforeDismiss?: () => void;
  onDismiss?: () => void;
};

export function ReassuranceScreen({ option, onBeforeDismiss, onDismiss }: ReassuranceScreenProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "supportMoments.reassuranceScreen" });
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      onBeforeDismiss?.();
      setIsVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [onBeforeDismiss]);

  return (
    <FadeTransition className="z-100" isVisible={isVisible} onTransitionEnd={onDismiss}>
      <PageModal showMobileIcon={false} hideBackForDesktop>
        <WaveBackground>
          <div className="flex flex-col items-center justify-center min-h-[50vh] text-center">
            <div className="z-30 space-y-4">
              <h1>{t(`${option}.heading`)}</h1>
              <h1>{t(`${option}.subheading`)}</h1>
            </div>
          </div>
        </WaveBackground>
      </PageModal>
    </FadeTransition>
  );
}
